import "./repo.2dc2aed2.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireff0f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireff0f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $hKdZU = parcelRequire("hKdZU");
(0, $hKdZU.default).data('meetJoin', ()=>({
        rawCode: '',
        bgColor: '#06b6d4',
        get displayCode () {
            const c = this.rawCode;
            if (c.length <= 3) return c;
            if (c.length <= 7) return `${c.slice(0, 3)}-${c.slice(3)}`;
            return `${c.slice(0, 3)}-${c.slice(3, 7)}-${c.slice(7)}`;
        },
        set displayCode (_){
        // handled by handleInput
        },
        get isValid () {
            return this.rawCode.length === 10;
        },
        handleInput (e) {
            const raw = e.target.value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 10);
            this.rawCode = raw.toLowerCase();
        },
        join () {
            if (!this.isValid) {
                this.$refs.codeInput.focus();
                return;
            }
            window.location.href = `https://meet.google.com/${this.displayCode}`;
        },
        init () {
            this.$refs.codeInput.focus();
        }
    }));
(0, $hKdZU.default).start();


//# sourceMappingURL=meet.2866bd52.js.map
